export const LOAD_BUSINESS_DAY_LIST = 'load_business_day_list';
export const LOAD_BUSINESS_DAY = 'load_business_day';
export const BUSINESS_DAY_LIST_LOADED = 'set_loaded_business_days_list';
export const BUSINESS_DAY_LOADED = 'set_loaded_business_day';
export const SAVE_BUSINESS_DAY = 'save_business_day';
export const BUSINESS_DAY_SAVED = 'business_day_saved';
export const BUSINESS_DAY_DELETED = 'business_day_deleted';
export const RESET_BUSINESS_DAY_LIST = 'reset_business_day_list';
export const RESET_BUSINESS_DAY = 'reset_business_day';
export const SYNC_FAILED = 'business_days_sync_error';
